import React, { useState } from 'react';
import { MessageSquare } from 'lucide-react';
import dayjs from 'dayjs';
import './MessageInput.css';
import { Message } from '../HomePage';

interface MessageInputProps {
  userId: string;
  userEmail: string;
  uploadMessage: (msg: Message) => Promise<void>;
}

const MessageInput: React.FC<MessageInputProps> = ({
  userId,
  userEmail,
  uploadMessage,
}) => {
  const isAdmin = userEmail === 'mehul.ajmer97@gmail.com';
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleMessageSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!userId || !message || (!isAdmin && message.length > 300)) return;
    setIsLoading(true);

    try {
      uploadMessage({
        title: message.trim(),
        createdByName: userEmail,
        createdById: userId,
        createdAt: dayjs().valueOf(),
      });
      setMessage('');
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      alert('Error sending message, please try again after some time.');
      console.error('Error adding message:', error);
    }
  };

  return (
    <section className="bg-white rounded-lg shadow-md p-6">
      <div className="flex items-center gap-2 mb-4">
        <MessageSquare className="w-6 h-6 text-indigo-600" />
        <h2 className="text-xl font-semibold">Write a Message</h2>
      </div>
      <form onSubmit={handleMessageSubmit} className="space-y-4">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Write your message here... (300 characters max)"
          className="w-full p-3 border rounded-lg h-32"
        />
        <div className="flex justify-between items-center">
          <span className="text-sm text-gray-500">
            {message.length} characters
          </span>
          <button
            type="submit"
            disabled={!message || !message.trim()}
            className="bg-indigo-600 text-white px-4 py-2 rounded-lg disabled:opacity-50">
            Post Message
          </button>
        </div>
      </form>
      {isLoading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            backgroundColor: 'rgba(0,0,0,.3)',
          }}></div>
      )}
    </section>
  );
};

export default MessageInput;
